import { UserHomeBaseType } from "Bands/types";
import { Car, Plane, Train } from "shared/assets/icons";

export const getHomeBaseTypeIcon = (type: UserHomeBaseType) => {
  switch (type) {
    case UserHomeBaseType.airport:
      return Plane;
    case UserHomeBaseType.carpool:
      return Car;
    case UserHomeBaseType.trainStation:
      return Train;
    default:
      return Train;
  }
};
